import { LogListingRow } from "../../../log_data";
import { FileLogItem, FolderLogItem, PendingTaskItem } from "../LogItem";

import { LogListRow } from "./columns/types";

export type LogListItem = FileLogItem | FolderLogItem | PendingTaskItem;

const rowForItem = (item: LogListItem): LogListingRow | undefined =>
  item.type === "file" ? item.log : undefined;

// A projection, not a computation: every derived value is read off the row
// (attached at ingestion by `detailTier`/`deriveLogFields`) so the grid can
// never disagree with what the store holds.
export const buildLogListRow = (item: LogListItem): LogListRow => {
  const log = rowForItem(item);
  const details = log?.header;
  const derived = log?.derived;

  const taskArgsSource = details?.eval.task_args_passed;

  const row: LogListRow = {
    id: item.id,
    name: item.name,
    displayIndex:
      item.type === "file" || item.type === "pending-task"
        ? item.displayIndex
        : undefined,
    type: item.type,
    url: item.url,
    task: item.type === "file" ? (log?.task ?? undefined) : item.name,
    model:
      item.type === "file"
        ? log?.model
        : item.type === "pending-task"
          ? item.model
          : undefined,
    modelRoles:
      item.type === "file" ? (log?.model_roles ?? undefined) : undefined,
    score: log?.primary_metric?.value,
    status: log?.status,
    completedAt: log?.completed_at,
    itemCount: item.type === "folder" ? item.itemCount : undefined,
    log: item.type === "file" ? item.log : undefined,
    path: item.type === "file" ? item.name : undefined,
    totalSamples: details?.results?.total_samples,
    completedSamples: details?.results?.completed_samples,
    sandbox: details?.eval.sandbox?.type,
    totalTokens: derived?.total_tokens,
    duration: derived?.duration,
    taskFile: details?.eval.task_file ?? undefined,
    taskArgs: derived?.task_args,
    taskArgsRaw: taskArgsSource ?? undefined,
    tags: details?.tags,
    percentCompleted: derived?.percent_completed,
    sampleErrors: details?.sampleErrorCount,
    sampleLimits: derived?.sample_limits,
    errorMessage: details?.error?.message,
  };

  // Individual scorer columns, keyed `score_<scorer>/<metric>`.
  if (derived?.scores) {
    for (const [scorerName, metrics] of Object.entries(derived.scores)) {
      for (const [metricName, value] of Object.entries(metrics)) {
        row[`score_${scorerName}/${metricName}`] = value;
      }
    }
  }

  return row;
};
